import { Address } from '@src/main/modules/messages/domain/address/address.interface';
import { Subject } from '@src/main/modules/messages/domain/subject/subject.interface';

export interface UpdateSubjectRequest {
  subjectId?: string;
  description: string;
  addresses: string[];
  visibleOnApp: boolean;
  scGroups?: { scGroup: string; priority: number }[];
}

export const updateRequestFromSubject = (subject: Subject): UpdateSubjectRequest => ({
  subjectId: subject.subjectId,
  description: subject.description,
  addresses: subject.addresses.map((address: Address) => address.addressId),
  visibleOnApp: subject.visibleOnApp,
  scGroups: subject.scGroups?.map((scGroup) => ({
    scGroup: scGroup.scGroup,
    priority: scGroup.priority,
  })),
});
